import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import { currentDomain, currentPath } from "../Index";
import { usePromotionsData } from "../data/PromotionData";
import { useNavigate } from "react-router-dom";
import useAppPromotionTheme from "../hooks/useAppPromotionTheme";

export default function BNGPrizeDrop({ isLightMode }) {
  const isAppPromo = useAppPromotionTheme(isLightMode);
  const { promotionsData, isPromotionDataReady } = usePromotionsData();
  const data = useMemo(
    () => promotionsData.find((promo) => promo.title === "BNG Prize Drop"),
    [promotionsData],
  );
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // If the promo page is expired - throws error
  useEffect(() => {
    if (!isPromotionDataReady) return;

    if (!data) {
      navigate("/not-found");
    }
  }, [isPromotionDataReady, data, navigate]);

  if (!isPromotionDataReady || !data) return null;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> BNG Prize Drop </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> BNG Prize Drop </h1>
                  <h2> Total Prize: ₱13,200,000 </h2>
                  <div className="promotion-tnc-period">
                    <strong> Event Period </strong>
                    <span> July 06 (12PM) - Sept 27 (12PM), 2026 </span>
                  </div>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong> Campaign Details </strong>
                  <ol>
                    <li>
                      <strong className="highlight">
                        Games Participating:{" "}
                      </strong>
                      All BNG games.
                    </li>
                    <li>
                      <strong className="highlight">Period: </strong> July 06 -
                      Sept 27, 2026 12:00 PM UTC+8 - Every Monday to Sunday
                    </li>
                    <li>
                      <strong className="highlight">Qualification: </strong>
                      Participants who place a minimum bet of 27.5 PHP per round
                      on any BNG game during the event period shall be eligible
                      to receive randomly awarded rewards.
                    </li>
                  </ol>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <th>Quantity</th>
                        <th>Prize</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>₱55,000</td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>₱27,500</td>
                        </tr>
                        <tr>
                          <td>10</td>
                          <td>₱5,500</td>
                        </tr>
                        <tr>
                          <td>30</td>
                          <td>₱2,750</td>
                        </tr>
                        <tr>
                          <td>50</td>
                          <td>₱550</td>
                        </tr>
                        <tr>
                          <td>500</td>
                          <td>₱275</td>
                        </tr>
                        <tr>
                          <td>11,000</td>
                          <td>₱55</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong>Terms & Conditions</strong>
                  <ol>
                    <li>All time mentioned above is based on UTC+8.</li>
                    <li>Only qualified rounds are counted in this campaign.</li>
                    <li>
                      All prizes and bets in the campaign become invalid if any
                      malfunction occurs.
                    </li>
                    <li>
                      Anyone who participates in this campaign is deemed to
                      agree with all the regulations of the campaign and the
                      casino, and is willing to abide by it, The organizer
                      reserves the right to modify and terminate this campaign
                      at any time.
                    </li>
                    <li>
                      Winners are able to claim their prizes in each
                      campaign-designated game by clicking the collect button on
                      the pop-up message after the campaign finishes. Please be
                      aware of the change in your account balance.
                    </li>
                    <li>
                      This event is only applicable to participating casino
                      platforms. If you do not see the event information in the
                      game, please contact your casino platform for confirmation
                    </li>
                  </ol>
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="https://servicebooongo.com//bngevent/event?event=202607PD&lang=en&currency=PHP"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
